import { Dropdown } from '@startuptools/ui/Dropdown';
import { MenuButton } from '@startuptools/ui/MenuButton';
import { MenuItem, type MenuItemProps } from '@startuptools/ui/MenuItem';
import { Menu } from '@startuptools/ui/Menu';
import { IconButton } from '@startuptools/ui/IconButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import React from 'react';

export const ActionMenu = ({ children }: { children: React.ReactNode }) => {
  return (
    <Dropdown>
      <MenuButton slots={{ root: IconButton }}>
        <MoreVertIcon />
      </MenuButton>
      <Menu>{children}</Menu>
    </Dropdown>
  );
};

export const ActionMenuItem = ({
  label,
  icon,
  action,
  ...props
}: {
  label: React.ReactNode;
  icon: React.ReactNode;
  action: () => unknown | Promise<unknown>;
} & Omit<MenuItemProps, 'action'>) => {
  return (
    <MenuItem {...props} onClick={action} color="primary">
      {icon}
      {label}
    </MenuItem>
  );
};
